import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import {
  FILTER_FIELD_STOCK_OUT_REPORT,
  STOCK_OUT_STATUS_OPTIONS,
} from './utils'

const StockOutReportFilterForm = () => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_STOCK_OUT_REPORT)

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <FilterTextInput
        label="Search"
        value={filters.search || ''}
        onApply={(value) => setField('search', value)}
        placeholder="Search barcode, store, hierarchy..."
      />

      {/* Free text rather than a store dropdown: an unmapped SAP store code is
          stored verbatim, so those rows have no store to pick from a list. */}
      <FilterTextInput
        label="Store Code"
        value={filters.store || ''}
        onApply={(value) => setField('store', value)}
      />

      <FilterTextInput
        label="Barcode"
        value={filters.barcode || ''}
        onApply={(value) => setField('barcode', value)}
      />

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={STOCK_OUT_STATUS_OPTIONS}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <FilterTextInput
        label="Dept"
        value={filters.dept || ''}
        onApply={(value) => setField('dept', value)}
      />

      <FilterTextInput
        label="Section"
        value={filters.section || ''}
        onApply={(value) => setField('section', value)}
      />

      <FilterTextInput
        label="Family"
        value={filters.family || ''}
        onApply={(value) => setField('family', value)}
      />

      <FilterDateInput
        label="Stock-out From"
        value={filters.stockOutFrom || ''}
        onChange={(value) => setField('stockOutFrom', value)}
      />

      <FilterDateInput
        label="Stock-out To"
        value={filters.stockOutTo || ''}
        onChange={(value) => setField('stockOutTo', value)}
      />

      {/* A stock-in range only ever matches entries that came back in stock,
          so it implicitly excludes still-open ones. */}
      <FilterDateInput
        label="Stock-in From"
        value={filters.stockInFrom || ''}
        onChange={(value) => setField('stockInFrom', value)}
      />

      <FilterDateInput
        label="Stock-in To"
        value={filters.stockInTo || ''}
        onChange={(value) => setField('stockInTo', value)}
      />
    </div>
  )
}

export default StockOutReportFilterForm
